import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "layouts/MainLayout";
// import DashboardPage from "pages/DashboardPage";
import ForgotPasswordPage from "pages/ForgotPasswordPage";
import LoginPage from "pages/LoginPage";
import ResetPasswordPage from "pages/ResetPasswordPage";
import AuditLogPage from "pages/AuditLogPage";
import IndustriesPage from "pages/IndustriesPage";
import { ProjectCreatePage, ProjectDetailsPage, ProjectsListPage } from "pages/project";
import {
  SettingsLayout,
  SettingsProfilePage,
  SettingsChangeImagePage,
  SettingsChangePasswordPage,
} from "pages/settings";
import { TransactionsPage } from "pages/transaction";
import UsersPage from "pages/UsersPage";
import UserDetailsPage from "pages/UserDetailsPage";
import ProtectedRoute from "routes/ProtectedRoute";
import GuestRoute from "routes/GuestRoute";
import { DEFAULT_APP_PATH } from "routes/paths";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<GuestRoute />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        </Route>

        <Route path="/reset-password" element={<ResetPasswordPage />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Navigate to={DEFAULT_APP_PATH} replace />} />
            {/* <Route path="dashboard" element={<DashboardPage />} /> */}
            <Route path="users" element={<UsersPage />} />
            <Route path="users/:userId" element={<UserDetailsPage />} />
            <Route path="projects" element={<ProjectsListPage />} />
            <Route path="projects/:projectId" element={<ProjectDetailsPage />} />
            <Route path="projects/new" element={<ProjectCreatePage />} />
            <Route path="projects/:projectId/edit" element={<ProjectCreatePage />} />
            <Route path="transactions" element={<TransactionsPage />} />
            <Route path="industries" element={<IndustriesPage />} />
            <Route path="audit-log" element={<AuditLogPage />} />
            <Route path="settings" element={<SettingsLayout />}>
              <Route index element={<Navigate to="profile" replace />} />
              <Route path="profile" element={<SettingsProfilePage />} />
              <Route path="image" element={<SettingsChangeImagePage />} />
              <Route path="password" element={<SettingsChangePasswordPage />} />
            </Route>
          </Route>
        </Route>

        <Route path="*" element={<Navigate to={DEFAULT_APP_PATH} replace />} />
      </Routes>
    </BrowserRouter>
  );
}
